define('glu/locale/localeBase',['require','../date','../defaultStrings','../number','../util'],function(require) {
    'use strict';

    var date = require('../date'),
        defaultStrings = require('../defaultStrings'),
        number = require('../number'),
        util = require('../util');

    function buildValue(template, params) {
        // If there are no dynamic value placeholders, return early
        if (template.indexOf('{') === -1) {
            return template;
        }

        // Replace dynamic value placeholders with real values
        util.each(params, function(value, index) {
            template = template.replace('{' + index + '}', value);
        });

        return template;
    }

    function getValue(key, pairs) {
        var keyParts = key.split('.'),
            flatResult = pairs[key],
            deepResult;

        // Basic support for a flat structure
        if (flatResult) {
            return flatResult;
        }

        // Support deep keys (e.g. `common.helloWorld`)
        deepResult = pairs;

        keyParts.forEach(function(part) {
            if (!deepResult) {
                return;
            }

            deepResult = deepResult[part];
        });

        return deepResult;
    }

    return {
        pairs: util.extend({}, defaultStrings),

        set: function(key, str) {
            if (util.isObject(key)) {
                this.pairs = util.extend(this.pairs, key);
                return;
            }

            this.pairs[key] = str;
        },

        get: function(key) {
            var result = getValue(key, this.pairs);

            var template = result || '??' + key + '??',
                params = util.rest(arguments);

            return buildValue(template, params);
        },

        getDefault: function(key, defaultValue) {
            if (!defaultValue) {
                throw new Error('No default value provided. Did you mean to use locale.get?');
            }

            var result = getValue(key, this.pairs);

            var template = result || defaultValue,
                params = util.rest(arguments, 2);

            return buildValue(template, params);
        },

        clear: function(resetToDefaultStrings) {
            this.pairs = resetToDefaultStrings ? util.extend({}, defaultStrings) : {};
        },

        //this function is to be implemented to form a fully working locale.js
        //it is deliberately not implemented here so that locale can work in a requireJs or webpack based build system
        //see glu/locale.js for the default requireJs implementation
        fetch: function(urlOrIsoCode, callback) {
            if (this.fetchFunction) {
                this.fetchFunction(urlOrIsoCode, callback);
            } else {
                throw 'fetchFunction must be implemented for locale!';
            }
        },

        loadFetchedBundle: function(bundle, callback) {
            // Append localised strings
            if (bundle.strings) {
                this.set(bundle.strings);
            }

            // Load localisation settings for momentjs
            if (bundle.dates && bundle.iso) {
                date.locale(bundle.iso);
            }

            // Load localisation settings for numeraljs
            if (bundle.numbers && bundle.iso) {
                number.language(bundle.iso, bundle.numbers);
                number.language(bundle.iso);
            }

            if (util.isFunction(callback)) {
                callback(bundle);
            }
        }
    };
});

